(() => {
  if (window.cnmOrderOptionsReady) return;
  window.cnmOrderOptionsReady = true;
  const standardInstructions = window.cnmText("Commandez au minimum 48 h avant le retrait. Pour bénéficier du plus grand choix et éviter un planning complet, nous vous recommandons de commander au moins 7 jours avant.");
  const labels = 'label,legend,[class*="label"],[data-option-label]';
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
  function fieldFor(label, product) {
    for (let node = label.parentElement; node && node !== product; node = node.parentElement) {
      if (!node.querySelector('input,select,textarea')) continue;
      const fields = [...node.querySelectorAll(labels)].filter(el => el !== label && !label.contains(el) && !el.contains(label) && normalize(el.textContent).length > 2);
      if (!fields.length) return node;
      if (node.matches('[data-option-id],.tpo_option-container,.tpo-option-container,.po-option,.product-option,.option-container,.option_container,fieldset')) return node;
    }
    return null;
  }
  function removeAccessoryDuplicates(product) {
    const headings=[...product.querySelectorAll('h2,h3,h4,p,div,span,strong,b,label,legend')].filter(el=>/^(accessoires supplementaires|extra accessories)$/.test(normalize(el.textContent))&&!el.closest('[data-cnm-accessories]'));
    for(const heading of headings){
      if(heading.closest('[data-cnm-old-accessories]'))continue;
      let group=null;
      for(let node=heading.parentElement;node&&node!==product;node=node.parentElement){
        const boxes=node.querySelectorAll('input[type="checkbox"]');
        if(boxes.length>=3&&!node.querySelector('input:not([type="checkbox"]):not([type="hidden"]),select,textarea')&&!node.querySelector('[data-cnm-accessories]')){group=node;break;}
      }
      const hide=(node)=>{node.hidden=true;node.style.setProperty('display','none','important');};
      const scope=group||heading.closest('.shopify-app-block')||heading.parentElement;
      for(const control of scope.querySelectorAll('input[type="checkbox"]')){
        if(control.closest('[data-cnm-accessories]'))continue;
        const label=control.closest('label')||scope.querySelector('label[for="'+CSS.escape(control.id)+'"]')||control.parentElement;
        const text=normalize(label.textContent+' '+control.value);
        let id=/happy birthday/.test(text)?'42700916064369':/topper.*personnalis/.test(text)?'42700916129905':/bougie/.test(text)?'42700916097137':null;
        if(!id&&group){const index=[...group.querySelectorAll('input[type="checkbox"]')].indexOf(control);id=['42700916064369','42700916129905','42700916097137'][index]||null;}
        if(!id)continue;
        if(control.checked){const replacement=product.querySelector('[data-cnm-accessories] [data-addon-variant="'+id+'"]');if(replacement)replacement.checked=true;control.checked=false;control.dispatchEvent(new Event('change',{bubbles:true}));}
        control.disabled=true;
        if(!group){hide(control);hide(label);}
      }
      if(group){group.dataset.cnmOldAccessories='';hide(group);}else hide(heading);
    }
  }
  function minimumLeadHours(product) {
    const id=product.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value;
    return id&&product.dataset.cnmBentoVariantIds?.split('|').includes(String(id))?24:48;
  }
  function sync(product) {
    const instructions=minimumLeadHours(product)===24?window.cnmText("Commandez votre bento cake au minimum 24 h avant le retrait. Pour bénéficier du plus grand choix et éviter un planning complet, nous vous recommandons de commander au moins 7 jours avant."):standardInstructions;
    removeAccessoryDuplicates(product);
    const selected=product.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if(selected&&product.dataset.cnmExcludedBentoVariants?.split('|').includes(String(selected.value))){
      const picker=product.querySelector('variant-selects');
      const first=picker?.querySelector('input[type="radio"],select');
      if(first&&!product.dataset.cnmResettingBento){
        product.dataset.cnmResettingBento='true';
        if(first.tagName==='SELECT'){first.selectedIndex=0;first.dispatchEvent(new Event('change',{bubbles:true}));}
        else first.click();
      }
    }else{delete product.dataset.cnmResettingBento;}

    const candidates = [...product.querySelectorAll(labels)];
    const colorLabels = {
      '7259006206065': ['Couleur du décor', 'Decoration colour'],
      '7257435897969': ['Couleur du ruban', 'Ribbon colour'],
      '7257481805937': ['Couleur du ruban', 'Ribbon colour'],
      '7257169068145': ['Couleur des mini cœurs', 'Mini heart colour']
    };
    const colorName = colorLabels[product.dataset.productId];
    for (const label of candidates) {
      if (!/^(couleur|colou?r)(?:\s*\*)?$/.test(normalize(label.textContent))) continue;
      if (product.dataset.productId === '7257169526897') {
        const field = fieldFor(label, product);
        if (!field || field.querySelector('input[type="date"],textarea,select')) continue;
        for (const control of field.querySelectorAll('input')) {
          control.required = false;
          control.disabled = true;
          if (control.type === 'radio' || control.type === 'checkbox') control.checked = false;
        }
        field.hidden = true;
        field.style.setProperty('display', 'none', 'important');
      } else if (colorName) {
        const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          const renamed = node.textContent.replace(/\b(?:couleur|colou?r)\b/i, colorName[document.documentElement.lang.startsWith('en') ? 1 : 0]);
          if (renamed !== node.textContent) node.textContent = renamed;
        }
      }
    }
    const flavorLabel = candidates.find(el => /^(?:choisissez (?:votre|la) )?(?:saveur|parfum|flavou?r)/.test(normalize(el.textContent)));
    if (flavorLabel) {
      const field = fieldFor(flavorLabel, product);
      const titleWalker = document.createTreeWalker(flavorLabel, NodeFilter.SHOW_TEXT);
      while (titleWalker.nextNode()) {
        const node = titleWalker.currentNode;
        const renamed = node.textContent.replace(/saveurs? compl[eè]tes?/gi, window.cnmText("Saveurs"));
        if (renamed !== node.textContent) node.textContent = renamed;
      }
      if (field) {
        const oldDescriptions = [...field.querySelectorAll('p,small,[class*="description"],[class*="help"],[class*="note"]')].filter(el => !el.closest('[data-cnm-flavor-help]') && !el.querySelector('input,select,textarea') && /composition complete|planning complet|complete flavour|fully booked/.test(normalize(el.textContent)));
        oldDescriptions.forEach(el => { if (!el.hidden) el.hidden = true; });
        let help = field.querySelector('[data-cnm-flavor-help]');
        if (!help) {
          help = document.createElement('div'); help.dataset.cnmFlavorHelp = '';
          help.style.cssText = 'font-size:13px;line-height:1.65;margin:10px 0 16px;color:inherit';
          const composition = document.createElement('p');
          composition.textContent = window.cnmText("Nos gâteaux sont composés de couches de génoise moelleuse, de ganache montée et d’un insert selon la saveur choisie. Le lissage est réalisé en crème au beurre à la meringue suisse.");
          help.append(composition); field.append(help);
        }
      }
      const app = field?.closest('.shopify-app-block');
      const pack = product.querySelector('cnm-kids-pack');
      const flavorGroup = app || field;
      if (pack && flavorGroup && !flavorGroup.contains(pack) && pack.nextElementSibling !== flavorGroup) {
        flavorGroup.parentNode.insertBefore(pack, flavorGroup);
      }
      if (app) {
        const holder = field.parentElement;
        if (holder.firstElementChild !== field) holder.insertBefore(field, holder.firstElementChild);
      }
    }
    for (const label of candidates) {
      const title = normalize(label.textContent);
      if (/^(?:date.*(?:recuperation|retrait|commande)|order collection date)/.test(title)) {
        const field = fieldFor(label, product);
        if (!field) continue;
        const oldHelp = [...field.querySelectorAll('p,small,[class*="description"],[class*="help"],[class*="note"]')].filter(el => !el.hasAttribute('data-cnm-date-help') && !el.hasAttribute('data-cnm-lead-error') && !el.querySelector('input,select,textarea') && /(?:24|48)\s*(?:h|heure)|7\s*(?:jours|days)|delai/i.test(normalize(el.textContent)));
        oldHelp.forEach(el => { if (!el.hidden) el.hidden = true; });
        let help = field.querySelector('[data-cnm-date-help]');
        if (!help) { help = document.createElement('p'); help.dataset.cnmDateHelp = ''; help.style.cssText = 'font-size:13px;line-height:1.65;margin:10px 0 16px;color:inherit'; field.append(help); }
        if (help.textContent !== instructions) help.textContent = instructions;
      }
      if (/set\s*up personnalise|personalised setup/.test(title)) {
        const field = fieldFor(label, product);
        if (!field) continue;
        const walker = document.createTreeWalker(field, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (['SCRIPT','STYLE','OPTION'].includes(node.parentElement?.tagName)) continue;
          const changed = node.textContent.replace(/\b1[\s\u00a0.,]?200(?=\s*(?:DH|MAD|dhs))/gi, '1 500');
          if (changed !== node.textContent) node.textContent = changed;
        }
      }
    }
  }
/** @param {number} timestamp */
function moroccoParts(timestamp) {
  const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Africa/Casablanca',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date(timestamp));
  return Object.fromEntries(parts.filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
}
/** @param {string} date @param {string} time */
function pickupTimestamp(date,time) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return NaN;
  const [year,month,day]=date.split('-').map(Number),[hour,minute]=time.split(':').map(Number);
  const desired=Date.UTC(year,month-1,day,hour,minute);let guess=desired;
  for(let i=0;i<4;i++){const p=moroccoParts(guess);const wall=Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute);if(wall===desired)break;guess+=desired-wall;}
  const p=moroccoParts(guess);
  return p.year===year&&p.month===month&&p.day===day&&p.hour===hour&&p.minute===minute?guess:NaN;
}
/** @param {number} [now] */
function minimumDate(now=Date.now(),hours=48) {const p=moroccoParts(now+hours*3600000);return `${p.year}-${String(p.month).padStart(2,'0')}-${String(p.day).padStart(2,'0')}`;}
/** @param {string} date @param {string} time @param {boolean} [secondary] @param {number} [now] */
function leadTimeIssue(date,time,secondary=false,now=Date.now(),hours=48) {
  const pickup=pickupTimestamp(date,time);
  if(!Number.isFinite(pickup))return window.cnmText("Choisissez une date et une heure de retrait valides.");
  if(pickup-now<hours*3600000)return window.cnmText(hours===24?"Un délai minimum de 24 h est nécessaire pour commander un bento cake. Choisissez une date et une heure de retrait plus tardives.":"Un délai minimum de 48 h est nécessaire pour commander. Choisissez une date et une heure de retrait plus tardives.");
  if(secondary&&pickup-now<7*24*3600000)return window.cnmText("Cette saveur nécessite au moins 7 jours de préparation. Choisissez une autre saveur ou une date de retrait plus tardive.");
  return null;
}


  function parseDate(value) {
    let match=value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if(match)return match[1]+'-'+match[2]+'-'+match[3];
    match=value.match(/^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})/);
    if(match)return match[3]+'-'+match[2].padStart(2,'0')+'-'+match[1].padStart(2,'0');
    return '';
  }
  function setupLeadTime(product) {
    if(product.cnmLeadTimeValidate)return;
    product.cnmLeadTimeValidate=(show=true,required=true)=>{
      const options=[...product.querySelectorAll(labels)];
      const dateLabel=options.find(el=>/^(?:date.*(?:recuperation|retrait|commande)|order collection date)/.test(normalize(el.textContent)));
      const dateField=dateLabel&&fieldFor(dateLabel,product);
      const dateInput=dateField?.querySelector('input[type="date"],input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])');
      if(!dateInput)return true;
      const date=parseDate(dateInput.value);
      const flavorLabel=options.find(el=>/^(?:choisissez (?:votre|la) )?(?:saveur|parfum|flavou?r)/.test(normalize(el.textContent)));
      const flavorField=flavorLabel&&fieldFor(flavorLabel,product);
      const selected=flavorField?[...flavorField.querySelectorAll('select option:checked,input:checked')].map(el=>el.tagName==='OPTION'?el.textContent:(el.value+' '+(flavorField.querySelector('label[for="'+CSS.escape(el.id)+'"]')?.textContent||''))).join(' '):product.querySelector('.product__title')?.textContent||'';
      const secondary=/caramel|lotus|pistache|citron|pistachio|lemon/i.test(selected);
      const timeLabel=options.find(el=>/^heure.*(?:retrait|recuperation)|^creneau|^collection time/.test(normalize(el.textContent)));
      const timeField=timeLabel&&fieldFor(timeLabel,product);
      const timeValue=timeField?.querySelector('input:not([type="hidden"]),select')?.value||product.querySelector('input[type="time"]')?.value||'';
      const timeMatch=(timeValue||dateInput.value).match(/(?:^|[T\s])(\d{1,2})[:h](\d{2})/i);
      const day=date?new Date(date+'T12:00:00Z').getUTCDay():0;
      const time=timeMatch?timeMatch[1].padStart(2,'0')+':'+timeMatch[2]:(day===2?'10:00':'11:00');
      let issue=!dateInput.value&&!required?null:leadTimeIssue(date,time,secondary,Date.now(),minimumLeadHours(product));
      const min=minimumDate(Date.now(),minimumLeadHours(product));
      if(dateInput.type==='date'&&dateInput.min!==min)dateInput.min=min;
      if(dateInput._flatpickr&&dateInput.dataset.cnmMinDate!==min){dateInput.dataset.cnmMinDate=min;dateInput._flatpickr.set('minDate',min);}
      let error=dateField.querySelector('[data-cnm-lead-error]');
      if(!error){error=document.createElement('p');error.dataset.cnmLeadError='';error.setAttribute('role','alert');error.style.cssText='color:#a13b42;font-size:14px;line-height:1.6;margin:12px 0';error.hidden=true;dateField.append(error);}
      if(show&&issue){if(error.textContent!==issue)error.textContent=issue;error.hidden=false;}
      else if(!issue)error.hidden=true;
      return !issue;
    };
    product.addEventListener('change',()=>product.cnmLeadTimeValidate(true,false));
    product.addEventListener('input',()=>product.cnmLeadTimeValidate(true,false));
    const guard=event=>{if(event.type==='click'&&!event.target.closest('button[name="add"],button[type="submit"],input[type="submit"],[name="checkout"]'))return;if(!product.cnmLeadTimeValidate()){event.preventDefault();event.stopImmediatePropagation();product.querySelector('[data-cnm-lead-error]')?.scrollIntoView({behavior:'smooth',block:'center'});}};
    product.addEventListener('submit',guard,true);product.addEventListener('click',guard,true);
    const timer=setInterval(()=>{if(!product.isConnected){clearInterval(timer);return;}product.cnmLeadTimeValidate(true,false);},30000);
  }
  function connect() {
    document.querySelectorAll('product-info').forEach(product => {
      if (product.dataset.cnmOptionsObserved) return;
      product.dataset.cnmOptionsObserved = 'true';
      setupLeadTime(product);
      let scheduled = false;
      const run = () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; sync(product); window.cnmTranslateOptions?.(product); product.cnmLeadTimeValidate(true,false); }); };
      new MutationObserver(run).observe(product, {childList:true,subtree:true,characterData:true});
      run();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, {once:true}); else connect();
  document.addEventListener('shopify:section:load', connect);
})();
